module.exports = __webpack_public_path__ + "img/gbwhatsapp-screen-1.27ff3974.webp";